import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { IEntityTypes, ISearchParams, ISearchProduct } from '@poinz/api';
import { getSearchFetchKey } from 'api/reactQuery';
import { NewPaginationModel } from '@poinz/api';
import DealCard from 'containers/Shop/ShopComponents/DealCard';
import api from 'api/api';
import AffiliateCard from 'containers/Shop/ShopComponents/AffiliateCard';
import Heading from 'components/text/Heading';
import { useTranslation } from 'next-i18next';
import DigitalVoucherCard from './DigitalVoucherCard';

interface Props {
  currentItemSlug: string;
}

const LIST_ID = 'more-offers';

const MoreOffers: React.FC<Props> = ({ currentItemSlug }) => {
  const { t } = useTranslation();
  const {
    data,
    isLoading: loading,
    error
  } = useQuery<any, any, NewPaginationModel<ISearchProduct>, any>({
    queryKey: getSearchFetchKey({
      page: 0
    }),
    queryFn: async () => {
      const res = await api.search.search.getProducts({
        size: 5,
        page: 0
      } as ISearchParams);
      return res;
    }
  });

  const { content: otherItems } = data || {};

  const filteredMoreItems = otherItems?.filter(item => item.slug !== currentItemSlug).slice(0, 4);

  if (!filteredMoreItems?.length) {
    return null;
  }
  return (
    <div className="my-12 md:my-16">
      <Heading variant="h4">{t('shop.moreOffers')}</Heading>
      <div className="flex lg:grid lg:grid-cols-4  overflow-auto gap-3 lg:gap-y-6 no-scrollbar mt-4 w-[100vw] lg:w-auto -ml-6 lg:ml-0 px-6 lg:px-0">
        {filteredMoreItems.map((item, i) => {
          if (item.productType === IEntityTypes.DEAL) {
            return (
              <div className="w-72 lg:w-auto shrink-0" key={`deal-${item.slug}`}>
                <DealCard
                  index={i}
                  listId={LIST_ID}
                  showLogo={false}
                  deal={{ ...item, ...item.dealData }}
                />
              </div>
            );
          }

          if (item.productType === IEntityTypes.AFFILIATE) {
            return (
              <div className="w-72 lg:w-auto shrink-0" key={`affiliate-${item.slug}`}>
                <AffiliateCard
                  index={i}
                  listId={LIST_ID}
                  showLogo={false}
                  affiliate={{ ...item, ...item.affiliateData }}
                />
              </div>
            );
          }

          if (item.productType === IEntityTypes.GIFT_CARD) {
            return (
              <div className="w-72 lg:w-auto shrink-0" key={`digitalVoucher-${item.slug}`}>
                <DigitalVoucherCard
                  index={i}
                  listId={LIST_ID}
                  showLogo={false}
                  digitalVoucher={item}
                />
              </div>
            );
          }

          return null;
        })}
      </div>
    </div>
  );
};

export default MoreOffers;
